import { BCMSRecord } from "@bcm-dev/bcms-vite";
import { Biller } from "model";

/**
 * @class AddBiller
 * @classdesc Class definition for the record type
 * @param {OBJECT} record - Record to init the class from
 * @extends BCMSRecord
 * @example const record = new AddBiller(model.billers[0]);
 */
export default class AddBiller extends BCMSRecord {
    constructor(record) {
        super(Object.assign(record, Biller.init(record), record));
    }   
}

AddBiller.define({
    "recordType" : "addBillers",
    "recordIDProp" : "billerID",
    "className" : "AddBiller",
    "recordProperties" : [].concat(Biller._RecordProperties)
});